import { dsColorBrandDahlia } from '@design/jw-design-library/dist/js/brand-colors';

export const LogoFull = (props: {
  className?: string;
  fill?: string;
  markColor?: 'inherit' | 'dahlia';
  width?: number;
}) => {
  props.fill ??= '#fff';
  props.markColor ??= 'inherit';
  props.width ??= 120;

  let markFill = '';
  switch (props.markColor) {
    case 'dahlia':
      markFill = dsColorBrandDahlia;
      break;
  }

  return (
    <svg viewBox="0 0 104 36.96" fill={props.fill} width={`${props.width}px`} className={props.className}>
      <path d="M36.59,22.09a3.21,3.21,0,0,0,1.91.69c1,0,1.38-.57,1.38-2V14.68h2.06v6.39c0,2.49-1.17,3.58-3.26,3.58a4.24,4.24,0,0,1-2.09-.56Z" />
      <polygon points="50.27 14.68 51.96 21.28 53.57 14.68 55.59 14.68 53.03 24.49 51.16 24.49 49.44 18.02 47.71 24.49 45.84 24.49 43.29 14.68 45.35 14.68 46.95 21.28 48.67 14.68 50.27 14.68" />
      <path d="M58.4,20.56v3.93H57.14V14.68h3.63c2,0,3.27,1,3.27,2.94s-1.29,2.94-3.27,2.94Zm2.35-4.77H58.4v3.65h2.35c1.33,0,2-.72,2-1.82s-.72-1.83-2-1.83" />
      <polygon points="65.83 14.68 67.09 14.68 67.09 23.36 72.09 23.36 72.09 24.49 65.83 24.49 65.83 14.68" />
      <path d="M76.32,14.68l3.84,9.81H78.88l-1.13-3h-4l-1.12,3H71.31l3.83-9.81Zm-2.2,5.75h3.19l-1.59-4.18Z" />
      <polygon points="86.37 14.68 87.71 14.68 84.13 20.45 84.13 24.49 82.89 24.49 82.89 20.45 79.34 14.68 80.72 14.68 83.54 19.32 86.37 14.68" />
      <polygon points="94.98 14.68 94.98 15.8 89.98 15.8 89.98 18.9 94.51 18.9 94.51 20.02 89.98 20.02 89.98 23.36 94.98 23.36 94.98 24.49 88.73 24.49 88.73 14.68 94.98 14.68" />
      <path d="M98,20.34v4.15H96.75V14.68h3.59c2,0,3.26,1,3.26,2.85a2.61,2.61,0,0,1-2.51,2.76l2.91,4.2h-1.44l-2.81-4.15Zm0-1.07h2.3c1.29,0,2-.66,2-1.74s-.76-1.74-2-1.74H98Z" />
      <path
        fill={markFill}
        d="M3.21,19c-.09.3-.23.29-.31,0l-.14-.53s-.2-.76-.54-1.66a2.58,2.58,0,0,0-.41-.83,1,1,0,0,0-1.12-.28,1,1,0,0,0-.68.85,3.8,3.8,0,0,0,.09,1,36.23,36.23,0,0,0,1.3,5.8,1.69,1.69,0,0,0,2.29.84,4.28,4.28,0,0,0,1.55-2.27C5.66,20.85,7.8,15,7.8,15c.21-.58.37-.55.36.07,0,0-.11,5.76-.12,8.4a16.22,16.22,0,0,0,.34,3.68,3.06,3.06,0,0,0,1,1.61,2.46,2.46,0,0,0,1.79.49,2.8,2.8,0,0,0,.89-.29,3.48,3.48,0,0,0,1-.9,16.21,16.21,0,0,0,1.58-2.66c1-2,3.69-8.31,3.69-8.31.24-.57.43-.53.41.09,0,0-.33,10.56-.34,14.59A8,8,0,0,0,19,34.67a3.6,3.6,0,0,0,1.83,2,3.17,3.17,0,0,0,2.89-.16,4.66,4.66,0,0,0,1.61-1.66A17.94,17.94,0,0,0,26.69,32c.8-2.08,1.47-4.21,2.12-6.33s6.31-22.28,6.66-24A1.69,1.69,0,0,0,35.52,1a1.19,1.19,0,0,0-.66-.93,1.26,1.26,0,0,0-1.66.6c-.31.62-8,19.32-8,19.32-.23.58-.43.54-.42-.08,0,0,0-6.5,0-11.88,0-2.92-1.42-4.55-3.43-4.88a3.81,3.81,0,0,0-2.67.59A6,6,0,0,0,16.79,6c-.62,1.19-4.38,12.22-4.38,12.22-.2.59-.37.56-.39-.06,0,0-.11-4.75-.22-5.87C11.64,10.6,11.25,7.77,9,7.64s-3,2.43-3.55,4c-.36,1.05-2.1,6.77-2.1,6.77Z"
      />
    </svg>
  );
};
